module.exports = __webpack_public_path__ + "img/big1-6.d8266db1.jpg";